<template>
    <console-layout width="100%" max-width="1600">

        <console-title>
            <span>회원목록</span>
        </console-title>

        <console-search @search="page = 1; search(true)">
            <v-row align="center">
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.createdAt[0]" label="가입일자" persistent-placeholder hide-details />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.createdAt[1]" label="가입일자" persistent-placeholder hide-details />
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.isAutoBlock" label="자동차단여부" persistent-placeholder hide-details :items="isBlocks" item-text="text" item-value="value"/>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.isBlock" label="관리자차단여부" persistent-placeholder hide-details :items="isBlocks" item-text="text" item-value="value"/>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.isDormancy" label="휴면여부" persistent-placeholder hide-details :items="isDormancies" item-text="text" item-value="value"/>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter['riskManagement.giftcard.level']" label="과금등급" persistent-placeholder hide-details :items="giftcardLevels" item-text="text" item-value="value"/>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.searchKey" label="검색조건" persistent-placeholder hide-details :items="searchKeys" item-text="text" item-value="value" @input="filter.searchValue = null;"/>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page=1; search(true)" />
                </v-col>
            </v-row>
        </console-search>

        <console-body>
            <v-layout class="align-end">
                <span class="ception">
                    검색된 회원수: <b>{{ summary.totalCount.format() }}</b>,
                    검색회원캐시 금액: <b>{{ summary.totalCashAmount.format() }}</b>,  
                    선물된캐시 금액: <b>{{ summary.unTakeCashAmount.format() }}</b>,
                    검색회원 포인트 금액: <b>{{ summary.totalPointAmount.format() }}</b>,
                </span>
                <v-spacer />
                <span>
                    <v-btn color="white" elevation="1" class="green--text px-2 ml-1" @click="excel">
                        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>엑셀다운로드
                    </v-btn>
                </span>
            </v-layout>
    
            <v-data-table :loading="loading" :items="members" :headers="membersHeaders" hide-default-footer disable-sort class="mt-2 elevation-1">
                <template v-slot:[`header.username`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'username')" @click="sortOptions(`username`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'username')"  @click="sortOptions(`username`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'username')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.name`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'name')" @click="sortOptions(`name`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'name')"  @click="sortOptions(`name`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'name')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.code`]="{header}">
                    <div class="d-flex flex-row justify-center align-center" style="gap: 8px">
                        <div style="white-space: pre-line"> {{ header.text }} </div>
                        <v-btn icon x-small>
                            <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'code')" @click="sortOptions(`code`, false)">mdi-arrow-up-bold-outline</v-icon>
                            <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'code')"  @click="sortOptions(`code`, true)">mdi-arrow-up-bold</v-icon>
                            <v-icon v-if="(filter.sortDesc && filter.sortBy == 'code')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                        </v-btn>
                    </div>
                </template>
                <template v-slot:[`header.point`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'point')" @click="sortOptions(`point`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'point')"  @click="sortOptions(`point`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'point')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.cash`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'cash')" @click="sortOptions(`cash`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'cash')"  @click="sortOptions(`cash`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'cash')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.createdAt`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'createdAt')" @click="sortOptions(`createdAt`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'createdAt')"  @click="sortOptions(`createdAt`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'createdAt')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.visitedCount`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'visitedCount')" @click="sortOptions(`visitedCount`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'visitedCount')"  @click="sortOptions(`visitedCount`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'visitedCount')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.visitedAt`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'visitedAt')" @click="sortOptions(`visitedAt`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'visitedAt')"  @click="sortOptions(`visitedAt`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'visitedAt')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template #[`header.loginFailedCount`]>
                    <v-layout align-center>
                        <div>로그인<br/>실패횟수</div>
                        <v-tooltip bottom>
                            <v-icon slot="activator" slot-scope="{ on, attrs }" small class="d-inline-block" v-on="on" v-bind="attrs">mdi-alert-circle-outline</v-icon>
                            <div>
                                <div class="font-size-14">* 로그인 실패 횟수는 다음날 자동으로 초기화 됩니다.</div>
                                <div class="font-size-14">* 초기화 버튼을 누르면, 오늘 로그인 실패횟수가 리셋됩니다.</div>
                            </div>
                        </v-tooltip>
                    </v-layout>
                </template>
                <template #[`item.phone`]="{item}">
                    <span v-if="item.phone">{{ item.phone.phoneNumberFormat() }}</span>
                    <span v-else>-</span>
                </template>
                <template #[`item.isAutoBlock`]="{item}">
                    <v-switch v-model="item.isAutoBlock" :disabled="!$hasScope(['root', 'admin'])" hide-details class="pa-0 ma-0 d-inline-block" color="red lighten-2" @change="update({ _id: item._id, isAutoBlock: item.isAutoBlock })"/>
                </template>
                <template #[`item.isBlock`]="{item}">
                    <v-switch v-model="item.isBlock" :disabled="!$hasScope(['root', 'admin'])" hide-details class="pa-0 ma-0 d-inline-block" color="red lighten-2" @change="update({ _id: item._id, isBlock: item.isBlock })"/>
                </template>
                <template #[`item.isDormancy`]="{item}">
                    <v-switch v-model="item.isDormancy" :disabled="!$hasScope(['root', 'admin'])" hide-details class="pa-0 ma-0 d-inline-block" color="red lighten-2" @change="update({ _id: item._id, isDormancy: item.isDormancy })"/>
                </template>
                <template #[`item.actions`]="{item}">
                    <v-icon small @click="edit(item)">mdi-pencil</v-icon>
                    <v-icon v-if="$hasScope(['root', 'admin'])" small class="ml-3" @click="withdrawal(item)">mdi-delete</v-icon>
                </template>
                <template #[`item.cash`]="{item}">{{ item.cash.format() }}</template>
                <template #[`item.cashRiskManagement`]="{item}">
                    <span>
                        {{ item.riskManagement.cash.limit.format() }}
                    </span>
                    <v-dialog max-width="400">
                        <template #activator="{ on }">
                            <v-icon small v-on="on">mdi-pencil</v-icon>
                        </template>
                        <v-card>
                            <v-card-text class="pa-4">
                                <v-text-field v-model="item.riskManagement.cash.limit" label="캐시 홀딩 금액(RM)" type="number" outlined hide-details />
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn @click="update({ _id: item._id, [`riskManagement.cash.limit`]: item.riskManagement.cash.limit }), search(), $emit('input', false)">확인</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </template>
                <template #[`item.point`]="{item}">{{ item.point.format() }}</template>
                <template #[`item.loginFailedCount`]="{item}">
                    {{ item.loginFailedCount[$dayjs().format("YYYY-MM-DD")] || 0 }} / 5
                    <v-icon :disabled="!$hasScope(['root', 'admin'])" small @click="update({ _id: item._id, loginFailedCount: new Map() }); item.loginFailedCount = {};">mdi-refresh</v-icon>
                </template>
                <template #[`item.createdAt`]="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD") }}</template>
                <template #[`item.visitedAt`]="{item}">{{ $dayjs(item.visitedAt).format("YYYY-MM-DD HH:mm:ss") }}</template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="my-4" @input="search(true)" />
        </console-body>


    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { mdiMicrosoftExcel, mdiPlusCircleMultipleOutline, mdiRefresh, mdiAlertCircleOutline } from "@mdi/js";

export default {
    components: {
        VDateField
    },
    data(){
        return {
            mdiRefresh,
            mdiMicrosoftExcel,
            mdiPlusCircleMultipleOutline,
            mdiAlertCircleOutline,

            showSearch: true,

            filter: {
                createdAt: [ this.$route.query.createdAt?.[0] || '', this.$route.query.createdAt?.[1] || '' ],
                "riskManagement.giftcard.level": this.$route.query["riskManagement.giftcard.level"] || null,
                isAutoBlock: this.$route.query.isAutoBlock ? this.$route.query.isAutoBlock === "true" : null,
                isBlock: this.$route.query.isBlock ? this.$route.query.isBlock === "true" : null,
                isDormancy: this.$route.query.isDormancy ? this.$route.query.isDormancy === "true" : null,
                isWithdrawal: false,
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                sortBy: null,
                sortDesc: null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "이름", value: "name" },
                { text: "아이디", value: "username" },
                { text: "연락처", value: "phone" },
                { text: "이메일", value: "email" },
                { text: "추천인 코드", value: "code" },
                // { text: "과금등급", value: "riskManagement.giftcard.level" },
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,
            loading: true,

            members: [],
            summary: { totalCount: 0 },
            membersHeaders: [
                { text: "아이디", value: "username", align: "center", width: 100 },
                { text: "회원이름", value: "name", align: "center", width: 110 },
                { text: "추천인\n코드", value: "code", align: "center", width: 110 },
                { text: "연락처", value: "phone", align: "center", width: 150 },
                { text: "포인트", value: "point", align: "center", width: 100 },
                { text: "캐시", value: "cash", align: "center", width: 100 },
                { text: "홀딩", value: "cashRiskManagement", align: "center", width: 100 },
                { text: "로그인 실패횟수", value: "loginFailedCount", align: "center", width: 120 },
                { text: "회원등급", value: "levelCode", align: "center", width: 100 },
                // { text: "과금등급", value: "riskManagement.giftcard.level", align: "center", width: 100 },
                { text: "자동차단안함 / 자동차단", value: "isAutoBlock", align: "center", width: 100 },
                { text: "관리자차단안함 / 관리자차단", value: "isBlock", align: "center", width: 100 },
                { text: "휴면안함 / 휴면", value: "isDormancy", align: "center", width: 100 },
                { text: "방문수", value: "visitedCount", align: "center", width: 90 },
                { text: "가입일자", value: "createdAt", align: "center", width: 120 },
                { text: "접속일자", value: "visitedAt", align: "center", width: 120 },
                { text: "최근접속IP", value: "visitedIp", align: "center", width: 100 },
                { text: "actions", value: "actions", align: "center", width: 100 },
            ],

            giftcardLevels: [
                { text: ":: 전체 ::", value: null },
                { text: "normal", value: "normal" },
                { text: "vip", value: "vip" },
                { text: "vvip", value: "vvip" },
            ],

            isBlocks: [
                { text: ":: 전체 ::", value: null },
                { text: "차단안함", value: false },
                { text: "차단", value: true }
            ],

            isDormancies: [
                { text: ":: 전체 ::", value: null },
                { text: "휴면안함", value: false },
                { text: "휴면", value: true }
            ],

            expanded:[],
            singleExpand: false
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            this.loading = true;
            this.members = [];
            let { summary, members } = await api.console.members.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.loading = false;
            this.members = members;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        edit(member){
            this.$router.push(`/console/members/${member._id}`);
        },

        async update(member){
            await api.console.members.put(member);
        },

        async withdrawal(member){
            if(confirm("탈퇴처리 하시겠습니까?")){
                await api.console.members.withdrawal(member);
                this.search();
            }
        },

        async excel(){

            var { members } = await api.console.members.gets({
                headers: {
                    limit: 0
                },
                params: this.filter
            });

            var rows = [];
            members.forEach(member => {
                rows.push({
                    "아이디": member.username,
                    "회원이름": member.name,
                    "연락처": member.phone,
                    "이메일": member.email,
                    "우편번호": member.postcode,
                    "기본주소": member.address1,
                    "상세주소": member.address2,
                    "포인트": member.point,
                    "캐시": member.cash,
                    "로그인 실패횟수": `${member.loginFailedCount[this.$dayjs().format("YYYY-MM-DD")] || 0} / 5`,
                    "과금등급": member.riskManagement.giftcard.level,
                    "자동차단안함 / 자동차단": member.isAutoBlock ? "자동차단" : "-",
                    "관리자차단안함 / 관리자차단": member.isBlock ? "차단" : "-",
                    "휴면안함 / 휴면": member.isDormancy ? "휴면" : "-",
                    "방문수": member.visitedCount || 0,
                    "가입일자": this.$dayjs(member.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                    "최근접속일자": this.$dayjs(member.visitedAt).format("YYYY-MM-DD HH:mm:ss"),
                    "SMS 수신여부": member.smsEnabled ? "수신" : "-",
                    "Email 수신여부": member.emailEnabled ? "수신" : "-",
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "new");
            XLSX.writeFile(workbook, "회원 목록.xlsx");
        },
        async sortOptions(sortBy, sortDesc) {
            this.filter.sortBy = sortBy;
            this.filter.sortDesc = sortDesc;
            await this.init();
        }
    }
}
</script>